// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog .search-contact[data-v-c75fec1c] {
  margin-bottom: 15px;
}
.dialog .search-wrapper[data-v-c75fec1c] {
  display: flex;
  overflow: hidden;
  flex-direction: column;
}
.dialog .select-contact[data-v-c75fec1c] {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px;
  overflow: hidden;
}
.dialog .right-block[data-v-c75fec1c] {
  display: flex;
  flex-direction: row;
}
.dialog[data-v-c75fec1c] .header {
  padding: 15px 20px 12px 15px;
}
.dialog[data-v-c75fec1c] .body {
  display: flex;
  flex-direction: column;
  overflow: hidden !important;
  height: auto;
}
.dialog[data-v-c75fec1c] .contact-list .contact-item {
  display: flex;
}
.dialog .recent-contacts .recent-text[data-v-c75fec1c] {
  height: 2em;
  font-size: var(--titleFontSize);
  color: var(--base-blue-color);
}
.dialog .contacts-list-item-wrapper[data-v-c75fec1c] {
  display: flex;
  width: 100%;
  height: 71px;
  padding-left: 1em;
}
.dialog .contacts-list-item-wrapper[data-v-c75fec1c]:hover {
  cursor: pointer;
  background-color: var(--list-item-bghover);
}
.dialog .contacts-list-item-wrapper .contacts-list-item[data-v-c75fec1c] {
  display: flex;
  justify-content: space-between;
  align-self: center;
  width: 100%;
}
.dialog .contacts-list-item-wrapper .contacts-list-item .sub-title[data-v-c75fec1c] {
  font-size: 0.8em;
  color: var(--bot-message-color);
}
.dialog .contacts-list-item-wrapper .contacts-list-item .missed-messages[data-v-c75fec1c] {
  display: flex;
  align-self: center;
  height: 21px;
  width: 22px;
  margin-right: 8px;
}
.dialog .contacts-list-item-wrapper .contacts-list-item .missed-messages .count[data-v-c75fec1c] {
  display: flex;
  justify-content: center;
  width: 100%;
  color: #FFFFFF;
  background: var(--elem-red-color);
  border-radius: 50%;
}
.dialog .line-separator[data-v-c75fec1c] {
  position: absolute;
  background: var(--hor-line-color);
  width: 100%;
  height: 1px;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/radio/SearchTetraContacts.vue"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,iCAAiC;EACjC,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;EACX,WAAW;AACb","sourcesContent":[".dialog .search-contact[data-v-c75fec1c] {\n  margin-bottom: 15px;\n}\n.dialog .search-wrapper[data-v-c75fec1c] {\n  display: flex;\n  overflow: hidden;\n  flex-direction: column;\n}\n.dialog .select-contact[data-v-c75fec1c] {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 0px;\n  overflow: hidden;\n}\n.dialog .right-block[data-v-c75fec1c] {\n  display: flex;\n  flex-direction: row;\n}\n.dialog[data-v-c75fec1c] .header {\n  padding: 15px 20px 12px 15px;\n}\n.dialog[data-v-c75fec1c] .body {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden !important;\n  height: auto;\n}\n.dialog[data-v-c75fec1c] .contact-list .contact-item {\n  display: flex;\n}\n.dialog .recent-contacts .recent-text[data-v-c75fec1c] {\n  height: 2em;\n  font-size: var(--titleFontSize);\n  color: var(--base-blue-color);\n}\n.dialog .contacts-list-item-wrapper[data-v-c75fec1c] {\n  display: flex;\n  width: 100%;\n  height: 71px;\n  padding-left: 1em;\n}\n.dialog .contacts-list-item-wrapper[data-v-c75fec1c]:hover {\n  cursor: pointer;\n  background-color: var(--list-item-bghover);\n}\n.dialog .contacts-list-item-wrapper .contacts-list-item[data-v-c75fec1c] {\n  display: flex;\n  justify-content: space-between;\n  align-self: center;\n  width: 100%;\n}\n.dialog .contacts-list-item-wrapper .contacts-list-item .sub-title[data-v-c75fec1c] {\n  font-size: 0.8em;\n  color: var(--bot-message-color);\n}\n.dialog .contacts-list-item-wrapper .contacts-list-item .missed-messages[data-v-c75fec1c] {\n  display: flex;\n  align-self: center;\n  height: 21px;\n  width: 22px;\n  margin-right: 8px;\n}\n.dialog .contacts-list-item-wrapper .contacts-list-item .missed-messages .count[data-v-c75fec1c] {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  color: #FFFFFF;\n  background: var(--elem-red-color);\n  border-radius: 50%;\n}\n.dialog .line-separator[data-v-c75fec1c] {\n  position: absolute;\n  background: var(--hor-line-color);\n  width: 100%;\n  height: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
